import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
window.onload = () => {
  setTimeout(() => {
    document.getElementById("loading").style.display = "none";
    console.log("loder");
  }, 1000);
};
createApp(App).use(router).mount("#app");
